import styled from '@emotion/styled';
import {
  MODIFIER_IS_OPEN,
  IS_FOCUSSED,
  NAV_MAIN_SECTION_HEIGHT,
  IS_STANDALONE_LINK,
} from '../../constants';

export const menuHoverTriggerLink = 'menu-hover-trigger-link';
export const dropDownDetailsContent = 'drop-down-details-content';

export const StyledWrapperDiv = styled.div`
  background-color: var(--podium-cds-color-bg-primary);
  a {
    color: var(--podium-cds-color-text-primary);
  }
  display: flex;
  padding-bottom: 0px;
  padding-left: 12px;
  min-height: ${NAV_MAIN_SECTION_HEIGHT}px;
  align-items: center;

  &.${IS_STANDALONE_LINK} {
    padding-right: 12px;
  }

  &.${IS_FOCUSSED} {
    transition: transform ease, opacity 0ms linear 250ms, visibility 0ms linear 250ms;
  }
  .${menuHoverTriggerLink} {
    // adds transparent border to prevent layout shift when border is added on hover
    color: var(--podium-cds-color-text-primary);
    border-bottom: 2px solid transparent;
    white-space: nowrap;
    &:hover {
      border-bottom: 2px solid var(--podium-cds-color-text-primary);
      // Override Podiums gray color when hovered
      color: var(--podium-cds-color-text-primary) !important;
    }
  }
  .${dropDownDetailsContent} {
    background-color: var(--podium-cds-color-bg-primary);
    padding: 0 48px 36px 48px;
    overflow-wrap: normal;
    display: flex;
    justify-content: center;

    position: absolute;
    overflow: hidden;
    max-height: 0;
    top: ${NAV_MAIN_SECTION_HEIGHT}px;
    left: 0;
    right: 0;
    transition: max-height 250ms;
    transform-origin: top center;

    [role='menu'] {
      opacity: 0;
      transform: translateY(-10px);
      transition: transform 100ms, opacity 100ms;
      transition-delay: 0;
    }

    &.${MODIFIER_IS_OPEN} [role='menu'] {
      opacity: 1;
      transform: translateY(0);
      transition: transform 300ms, opacity 200ms linear;
      transition-delay: 200ms;
    }
  }
  .${MODIFIER_IS_OPEN} {
    max-height: 800px;
    height: auto;
    transition: max-height 250ms;
    z-index: 3;
  }
`;
